import { jsx as n } from "react/jsx-runtime";
import { useMemo as c } from "react";
import { chakra as s } from "@chakra-ui/react";
import { FontAwesomeIcon as f } from "@fortawesome/react-fontawesome";
import { iconSizeStyles as p } from "../../../theme/foundations/icons.mjs";
const w = ({
  __css: t,
  icon: o,
  size: r,
  viewBox: m = `0 0 ${o.icon[0]} ${o.icon[1]}`,
  ...e
}) => {
  const i = c(() => s(f), []);
  return /* @__PURE__ */ n(
    i,
    {
      __css: { fontSize: "inherit", ...t },
      icon: o,
      ...r && { ...p[r] },
      width: "1em",
      viewBox: m,
      ...e
    }
  );
};
export {
  w as FAIcon
};
